import { Radio } from '../../../../input/Radio';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { Wrapper } from './styles';
import type { ContentPromotionPostsRadioProps } from './types';

export const ContentPromotionPostsRadio: React.FC<ContentPromotionPostsRadioProps> = ({
    title,
    text,
    value,
    children,
    ...other
}) => (
    <Wrapper {...other}>
        <Radio value={value} checked={other.checked} />
        <Flex mt={{ xs: 0, sm: 2 }} ml={{ xs: 2, sm: 0 }}>
            <Typography variant="body" weight="bold">
                {title}
            </Typography>
            {text ? (
                <Typography variant="body2" mt={1}>
                    {text}
                </Typography>
            ) : null}
            {children}
        </Flex>
    </Wrapper>
);
